import { Grid, makeStyles, Typography } from '@material-ui/core/';
import React from 'react';
import { toPrice } from '~/utils/format';
import { useSelector } from 'react-redux';
import * as shoppingCartSelectors from '~/store/legacy/selector/shoppingCartSelectors';

export default PriceLineTotal;

const useStyles = makeStyles({
  totalLine: {
    paddingTop: 24,
    marginRight: 12,
  },
  totalText: {
    fontFamily: 'proximanova-bold',
    textAlign: 'right',
  },
});

function PriceLineTotal() {
  const classes = useStyles();
  const totalAmount = useSelector(shoppingCartSelectors.checkoutTotalAmount);
  const totalWithTipsValue = useSelector(shoppingCartSelectors.checkoutTotalWithTips);

  console.log('PriceLineTotalPriceLineTotalPriceLineTotal');
  return (
    <Grid container justify='flex-end' alignItems='center' className={classes.totalLine}>
      {totalAmount && (
        <Typography className={classes.totalText} aria-label='Shopping Cart Total'>
          {totalAmount.customerDisplayName}: {toPrice(totalWithTipsValue)}
        </Typography>
      )}
    </Grid>
  );
}
